import axios from "axios";

// Frontend and backend are always reachable through the SAME origin in both
// preview and production (the Kubernetes ingress / Emergent platform proxies
// `/api/*` to the FastAPI backend on both environments). Using a relative
// base URL means the bundle works wherever it's deployed without having to
// bake an absolute backend URL into the build — which previously caused
// production at interquests.org to try calling the *preview* backend and
// get blocked by CORS.
//
// REACT_APP_BACKEND_URL is still respected as an override for special cases
// (e.g. running the frontend locally against a remote backend), but defaults
// to "" so axios resolves /api/* against window.location.origin.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL_OVERRIDE || "";
export const API = `${BACKEND_URL}/api`;

// withCredentials: true so the httpOnly auth cookie set by the backend on
// /api/auth/login is automatically sent on every subsequent /api call.
export const api = axios.create({ baseURL: API, withCredentials: true });

// One-time migration: clear any stale localStorage JWT from the pre-cookie era
// so old tokens don't linger in user browsers.
try { localStorage.removeItem("iq_token"); } catch (_) {}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtDuration(sec) {
  if (sec == null) return "—";
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (h === 0) return `${m}m`;
  return `${h}h ${m.toString().padStart(2, "0")}m`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString([], { weekday: "short", day: "2-digit", month: "short" });
}

export function modeLabel(mode) {
  if (!mode) return "";
  return mode.replace(/_/g, " ");
}

export function modeClass(mode) {
  if (!mode) return "mode-pill-walk";
  if (mode === "WALK") return "mode-pill-walk";
  if (mode.includes("HIGHSPEED")) return "mode-pill-highspeed";
  if (mode.includes("NIGHT")) return "mode-pill-night";
  return "mode-pill-regional";
}

// crude price estimator (display only — booking deferred)
export function estimatePriceEur(durationSec, mode) {
  if (!durationSec) return 0;
  const hours = durationSec / 3600;
  if (mode && mode.includes("HIGHSPEED")) return Math.round(hours * 22);
  if (mode && mode.includes("NIGHT")) return Math.round(40 + hours * 8);
  return Math.round(hours * 14);
}
